<a
  *ngIf="link"
  [routerLink]="link"
  style="box-shadow: rgba(0, 168, 147, 0.36) 0rem 0.625rem 1.875rem"
  class="w-16 h-16 md:w-20 md:h-20 text-lg text-center tracking-wider flex justify-center items-center bg-transparent {{
    customClass
  }} font-semibold bg-kimbo-gradient bg-no-repeat bg-origin-padding bg-clip-padding text-white cursor-pointer"
>
  <img appImg [src]="icon" class="w-8 h-8 animate-pulse" alt="chat" />
</a>
<a
  *ngIf="!link"
  style="box-shadow: rgba(0, 168, 147, 0.36) 0rem 0.625rem 1.875rem"
  class="w-20 h-20 text-lg text-center tracking-wider flex justify-center items-center bg-transparent {{
    customClass
  }} font-semibold bg-kimbo-gradient bg-no-repeat bg-origin-padding bg-clip-padding text-white cursor-pointer"
>
  <img appImg [src]="icon" class="w-8 h-8 animate-pulse" alt="chat" />
</a>
